import { Component } from "react"

class ImageFile extends Component{
    constructor(props){
        super(props)
        this.name = "画像"
        this.file = props.file
        this.imageData = props.imageData
        this.imageDataMiddle = props.imageDataMiddle
        this.imageDataOriginal = props.imageDataOriginal
        this.imageDataEdited = props.imageDataEdited
        this.useMosaic = props.useMosaic || "0"
        this.prompt = props.prompt || ""
        this.software = props.software || "no-select"
        this.softwareLocked = props.softwareLocked || "0"
        this.modelId = props.modelId || ""
        this.modelHash = props.modelHash || ""
        this.vae = props.vae || ""
        this.gpu = props.gpu || ""
        this.vram = props.vram || ""
        this.rawInfo = props.rawInfo || ""
        this.useAIGeneration = false
        this.comment = props.comment || {uc:"",noise:"",steps:"",scale:"",seed:"",sampler:"",strength:"",maskBlur:"",
            clipSkip:"",
            controlNetEnabled:"",
            controlNetModule:"",
            controlNetModel:"",
            controlNetWeight:"",
            ensd:"",
            hiresUpscale:"",
            hiresUpscaler:""
        }
        this.nsfw = props.nsfw || false
        this.error = false
    }
    validate(callbackDialog,requireCheck){
        if(requireCheck && String(this.props).trim().length === 0){
            callbackDialog("エラー",this.name + "は必須です。")
            return false
        }
        return true
    }
}

export default ImageFile;